const HEX_RADIX = 16
const UUID_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
const VARIANT_BASE = 8
const VARIANT_RANGE = 4

/** Batch id for the upload analytics. `randomUUID` needs a secure context, hence the fallback. */
export const generateId = (): string => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
    }

    return UUID_TEMPLATE.replace(/[xy]/g, character => {
        const random = Math.trunc(Math.random() * HEX_RADIX)
        // The `y` slot must be 8, 9, a or b — the RFC 4122 variant bits.
        const value = character === 'x' ? random : (random % VARIANT_RANGE) + VARIANT_BASE

        return value.toString(HEX_RADIX)
    })
}
